export enum RelationType {
  Spdr = 0,
  Pdsr = 1,
}
